import React, { useEffect, useState } from 'react';
import { TrendingUp, Clock } from 'lucide-react';
import { getDashboardOverview } from '../services';

// Dashboard: slots para embeds do Power BI + listas de obras e concretagens recentes.
function DashboardPage() {
  const [overview, setOverview] = useState({
    recentObras: [],
    recentConcretagens: [],
  });
  const [loading, setLoading] = useState(true);

  // Carrega o resumo do dashboard ao montar (guard isMounted evita setState após desmontar).
  useEffect(() => {
    let isMounted = true;
    const loadOverview = async () => {
      try {
        const data = await getDashboardOverview();
        if (isMounted) {
          setOverview(data);
        }
      } catch (error) {
        if (isMounted) {
          setOverview({ recentObras: [], recentConcretagens: [] });
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    loadOverview();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="dashboard-page space-y-6 sm:space-y-8">
      <section className="dashboard-header">
        <h2 className="dashboard-title text-2xl font-semibold text-slate-900 sm:text-3xl">
          Visao geral
        </h2>
        <p className="mt-2 max-w-2xl text-sm text-slate-500">
          Acompanhe os principais indicadores do sistema e as atividades mais recentes.
        </p>
      </section>

      <section className="powerbi-grid grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={`powerbi-${index}`}
            className="powerbi-card rounded-2xl border border-dashed border-slate-200 bg-white/80 p-4 shadow-sm sm:p-5"
          >
            <div className="powerbi-card-header flex items-center justify-between">
              <div>
                <p className="text-xs uppercase tracking-[0.3em] text-slate-400">
                  Power BI
                </p>
                <p className="mt-2 text-sm font-medium text-slate-700">
                  Gráfico integrado {index + 1}
                </p>
              </div>
              <span className="rounded-full bg-slate-100 px-3 py-1 text-[11px] font-medium text-slate-500">
                Placeholder
              </span>
            </div>
            <div
              className="powerbi-embed-slot mt-4 flex h-40 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-xs text-slate-400 sm:h-44"
              data-powerbi-slot={`grafico-${index + 1}`}
            >
              Area reservada para o embed do Power BI
            </div>
          </div>
        ))}
      </section>

      <section className="activity-grid grid gap-4 sm:gap-6 lg:grid-cols-2">
        <div className="activity-card rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
          <div className="activity-card-header flex items-center gap-2 text-slate-900">
            <TrendingUp className="h-5 w-5" />
            <h3 className="text-lg font-semibold">Obras recentes</h3>
          </div>
          <div className="activity-list mt-4 space-y-4">
            {overview.recentObras.length === 0 ? (
              <p className="text-sm text-slate-500">Nenhuma obra cadastrada.</p>
            ) : (
              overview.recentObras.map((obra) => (
                <div
                  key={obra.id}
                  className="activity-row flex items-center justify-between border-b border-slate-100 pb-3 last:border-0 last:pb-0"
                >
                  <div>
                    <p className="text-sm font-medium text-slate-900">{obra.nome}</p>
                    <p className="text-xs text-slate-500">{obra.empresa}</p>
                  </div>
                  <span
                    className={`rounded-full px-2 py-1 text-xs font-medium ${obra.ativo
                        ? 'bg-emerald-100 text-emerald-700'
                        : 'bg-slate-100 text-slate-600'
                      }`}
                  >
                    {obra.ativo ? 'Ativa' : 'Inativa'}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="activity-card rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
          <div className="activity-card-header flex items-center gap-2 text-slate-900">
            <Clock className="h-5 w-5" />
            <h3 className="text-lg font-semibold">Atividades recentes</h3>
          </div>
          <div className="activity-list mt-4 space-y-4">
            {overview.recentConcretagens.length === 0 ? (
              <p className="text-sm text-slate-500">Nenhuma concretagem registrada.</p>
            ) : (
              overview.recentConcretagens.map((item) => (
                <div
                  key={item.id}
                  className="activity-row flex items-center justify-between border-b border-slate-100 pb-3 last:border-0 last:pb-0"
                >
                  <div>
                    <p className="text-sm font-medium text-slate-900">Concretagem</p>
                    <p className="text-xs text-slate-500">{item.obra}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-slate-700">{item.volume} m3</p>
                    <p className="text-xs text-slate-400">{item.dataFormatada}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default DashboardPage;
